import * as color from "../../constants/color";
import * as texchangePropTypes from "../../texchangePropTypes";
import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
    text: {
        color: color.darkestBlueAlpha80,
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: 0.2,
        lineHeight: "20px",
        margin: 0,
    },
});

export default function BodyCopyHighlight(props) {
    const { aStyles, children, ...rest } = props;
    return (
        <span {...rest} className={css(styles.text, aStyles)}>
            {children}
        </span>
    );
}

BodyCopyHighlight.propTypes = {
    aStyles: texchangePropTypes.aphroditeStyles,
    children: PropTypes.node,
};
